import { CalendarDays } from 'lucide-react'

const NewThisMonthCallout = ({ headline, summary, sourceUrl }) => (
  <div className="rounded-xl border border-[#FF914D]/40 bg-[#fff3ec] p-5 sm:p-6">
    <div className="mb-2 flex items-center gap-2">
      <CalendarDays
        className="h-5 w-5 shrink-0 text-[#FF914D]"
        aria-hidden="true"
      />
      <span className="text-foreground text-sm font-bold tracking-wide uppercase">
        New this month
      </span>
    </div>
    <h2 className="text-foreground mb-1 text-lg font-bold sm:text-xl">
      {headline}
    </h2>
    <p className="text-foreground mt-2 text-sm leading-relaxed sm:text-base">
      {summary}
    </p>
    {sourceUrl && (
      <p className="text-foreground mt-3 text-sm font-semibold">
        Read more{' '}
        <a
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Read more about this FCA update (opens in a new tab)"
          className="hover:text-foreground text-[#FF914D] underline underline-offset-2"
        >
          here
        </a>
      </p>
    )}
  </div>
)

export default NewThisMonthCallout
